import React from 'react';
import styled from 'styled-components';

import { SIDEBAR_DELAY } from '@/config/variables';
import { media } from '@/styles/theme';

interface IProps {
  children?: React.ReactNode;
}

const ContentTitle = ({ children }: IProps): React.ReactElement => {
  return <Title>{children}</Title>;
};

const Title = styled.div`
  display: flex;
  font-weight: 300;
  font-size: 20px;
  line-height: 1.4;
  color: #0a4599;
  margin-bottom: 8px;
  transition: font-size ${SIDEBAR_DELAY};

  ${media.tablet} {
    font-size: 24px;
  }
`;

export { ContentTitle };
